import { render } from "./AuthSettingsButton.vue?vue&type=template&id=40d70287&scoped=true&ts=true"
import script from "./AuthSettingsButton.vue?vue&type=script&lang=ts"
export * from "./AuthSettingsButton.vue?vue&type=script&lang=ts"

import "./AuthSettingsButton.vue?vue&type=style&index=0&id=40d70287&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d70287"]])

export default __exports__